import { Popover } from '@mui/material'
import type { GridRenderCellParams } from '@mui/x-data-grid'
import _ from 'lodash'
import type React from 'react'
import { useRef, useState } from 'react'
import { MediaSizes } from '@/features/media/types'
import { useMediaImage } from '@/features/media/useMediaImage'
import { useAnchorToCenter } from '@/layout/hooks/useAnchorToCenter'
import { useIsOnScreen } from '@/layout/hooks/useIsOnScreen'

type Props = GridRenderCellParams

export const ThumbnailCell = (props: Props) => {
  const imgRef = useRef(null)
  const isThumbnailOnScreen = useIsOnScreen(imgRef, undefined, '100%')
  const shouldFetchthumbnail = isThumbnailOnScreen

  const [shouldFetchPreview, setShouldFetchPreview] = useState(false)

  const { url: thumbnailUrl, request: thumbnailRequest } = useMediaImage(
    props.row,
    MediaSizes.Small,
    shouldFetchthumbnail,
  )

  const {
    url: previewUrl,
    request: _previewRequest,
    isFallback,
  } = useMediaImage(props.row, MediaSizes.Medium, shouldFetchPreview)

  const [anchorEl, setAnchorEl] = useState<null | Element>(null)
  const isOpen = Boolean(anchorEl)

  const popoverOrigin = useAnchorToCenter('both', anchorEl)

  const handleOpen = (event: React.MouseEvent) => {
    event.stopPropagation()
    setShouldFetchPreview(true)
    const anchor = isOpen ? null : event.currentTarget
    setAnchorEl(anchor)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleMouseEnter = () => {
    setShouldFetchPreview(true)
  }

  return (
    <>
      <img
        ref={imgRef}
        height="100%"
        width="100%"
        style={{
          cursor: 'pointer',
          objectFit: 'contain',
          opacity: thumbnailRequest.isLoading ? 0.5 : 1,
          mixBlendMode: 'darken',
        }}
        src={thumbnailUrl}
        onClick={handleOpen}
        onMouseEnter={handleMouseEnter}
      />
      <Popover
        {...popoverOrigin}
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        disableScrollLock
      >
        <img
          style={{
            margin: 0,
            padding: 0,
            height: '40dvh',
            maxWidth: '90dvw',
            objectFit: 'fill',
          }}
          src={(!isFallback && previewUrl) || thumbnailUrl}
        />
      </Popover>
    </>
  )
}
